import { render } from "./IconGiveaways.vue?vue&type=template&id=501001cc&ts=true"
import script from "./IconGiveaways.vue?vue&type=script&lang=ts"
export * from "./IconGiveaways.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__